import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "tw-w-56 tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-backdrop-blur tw-shadow-lg tw-shadow-slate-900/10",
  role: "menu",
  ref: "menuEl"
}
const _hoisted_2 = { class: "tw-py-1" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tw-relative",
    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-text-slate-600 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white focus:tw-outline-none focus:tw-ring-0",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"])),
      ref: "triggerEl"
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "cog",
        class: "tw-h-4 tw-w-4"
      })
    ], 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tw-fixed tw-z-50",
            style: _normalizeStyle(_ctx.menuStyle),
            onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                  href: _ctx.printBLUrl(_ctx.container.id),
                  target: "_blank",
                  role: "menuitem",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "print",
                    class: "tw-h-4 tw-w-4 tw-text-slate-500"
                  }),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "Print BL", -1))
                ], 8, _hoisted_3),
                (_ctx.container.isActive && !_ctx.order.isExport && !_ctx.isLand)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onShowContainer && _ctx.onShowContainer(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "eye",
                        class: "tw-h-4 tw-w-4 tw-text-slate-500"
                      }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "View Container Status", -1))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isLand)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEditContainerDetails && _ctx.onEditContainerDetails(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "pen",
                        class: "tw-h-4 tw-w-4 tw-text-slate-500"
                      }),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "Edit Container Details", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onEditFreightContent && _ctx.onEditFreightContent(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "pen",
                        class: "tw-h-4 tw-w-4 tw-text-slate-500"
                      }),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "Edit Freight Contents", -1))
                    ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                  role: "menuitem",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onToggleTripStatus && _ctx.onToggleTripStatus(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "route",
                    class: "tw-h-4 tw-w-4 tw-text-slate-500"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "View Trip Status", -1))
                ]),
                (!_ctx.getIsContainerCancelled && (!_ctx.container.trips || _ctx.container.trips.length == 0))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAddTrip && _ctx.onAddTrip(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "plus",
                        class: "tw-h-4 tw-w-4 tw-text-slate-500"
                      }),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, "Add Trip", -1))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.getIsContainerCancelled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-rose-700 hover:tw-bg-rose-50/80 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onCancelContainer && _ctx.onCancelContainer(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "ban",
                        class: "tw-h-4 tw-w-4"
                      }),
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "Cancel container", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getIsContainerCancelled)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      type: "button",
                      class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-text-slate-700 hover:tw-text-blue-600 hover:tw-bg-slate-900/5 tw-no-underline hover:tw-no-underline",
                      role: "menuitem",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onUncancelContainer && _ctx.onUncancelContainer(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "rotate-left",
                        class: "tw-h-4 tw-w-4 tw-text-slate-500"
                      }),
                      _cache[18] || (_cache[18] = _createElementVNode("span", null, "Restore container", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512)
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ]))
}